import React from 'react'
import colors from '@settings/styleSettings'

import Text from './Text'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize: 10,
    color: colors.strongGray,
  },
  text: {
    margin: 0,
  },
}

// Create Document Component
export const Footer = () => (
  <div style={styles.container}>
    <Text style={styles.text}>Medicina Preventiva - Unimed Assis</Text>
    <Text style={styles.text}>
      Avenida Walter Antônio Fontana, 1997, Vila Cláudia - Assis/SP
    </Text>
    <Text style={styles.text}>
      E-mail: medicina.preventiva@unimed-assis.com.br
    </Text>
    <Text style={styles.text}>Telefone: (18) 99709-1663</Text>
  </div>
)
